import { render, staticRenderFns } from "./TradingView.vue?vue&type=template&id=28f16b7f&scoped=true"
import script from "./TradingView.vue?vue&type=script&lang=js"
export * from "./TradingView.vue?vue&type=script&lang=js"
import style0 from "./TradingView.vue?vue&type=style&index=0&id=28f16b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f16b7f",
  null
  
)

export default component.exports